export const subscriptionsRoutes = {
  SUBSCRIBE: "subscribe",
  CHOOSE_PLAN: "choosePlan",
  MY_SUBSCRIPTION: "my_subscription_fee",
};
